/// <reference path="../../_ext/Bases/MFGTransDialog.ts" />
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class TreeMakingDialog extends _Ext.MFGTransDialog<TreeMakingRow, any> {
        protected getFormKey() { return TreeMakingForm.formKey; }
        protected getIdProperty() { return TreeMakingRow.idProperty; }
        protected getLocalTextPrefix() { return TreeMakingRow.localTextPrefix; }
        protected getNameProperty() { return TreeMakingRow.nameProperty; }
        protected getService() { return TreeMakingService.baseUrl; }
        protected getDeletePermission() { return TreeMakingRow.deletePermission; }
        protected getInsertPermission() { return TreeMakingRow.insertPermission; }
        protected getUpdatePermission() { return TreeMakingRow.updatePermission; }
        protected useViewMode() { return true; }
        public form = new TreeMakingForm(this.idPrefix);
        public Closing: boolean;

        constructor() {
            super();
            var IConfig = Q.deepClone(q.DefualtEditorOptions);
            var RConfig = Q.deepClone(q.DefualtEditorOptions);
            IConfig.height = 300;
            IConfig.autoHeight = false;
            RConfig.height = 200;
            RConfig.autoHeight = false;

            q.initMFGItemEditor(this, this.form.ItemDetails, IConfig);
            q.initMFGItemEditor(this, this.form.IssueDetails, RConfig);
            q.initMFGItemEditor(this, this.form.ReceiptDetail, RConfig);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.IssueDetails);
            q.hideEditorLabel(this.form.ReceiptDetail);
            q.setTextRightAlign(this.form.BaseWeight);
            q.setTextRightAlign(this.form.TreeWeight);
            q.setTextRightAlign(this.form.ConversionFactor);
            q.setTextRightAlign(this.form.ButtonWeight);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.MetalBalance);
            q.setTextRightAlign(this.form.MetalConsumed);
            q.setTextRightAlign(this.form.MetalIssued);
            q.setTextRightAlign(this.form.MetalRequired);
            q.setTextRightAlign(this.form.Loss);
            q.setTextRightAlign(this.form.LossPercent);
            q.HideCategoryLable(this.element);
            q.SetSix12Column(this.form.ItemDetails);
            q.SetSix12Column(this.form.IssueDetails);
            q.SetCategoryFullWidth(this.form.Remark);



            this.form.KaratId.changeSelect2(e => {
                this.form.ConversionFactor.value = OMS.AttributeMasterRow.getLookup().itemById[this.form.KaratId.value].SPGravity;
            });
            this.form.DepartmentId.changeSelect2(e => {
                this.form.ItemDetails.DeptId = parseInt(this.form.DepartmentId.value);
            });
            this.form.DepartmentId.changeSelect2(e => {
                this.form.ProcessId.cascadeField = "DepartmentId";
                this.form.ProcessId.cascadeValue = this.form.DepartmentId.value;
            });

            this.form.BaseWeight.changeSelect2(e => {
                this.calculateMetalRequired();
            });
            this.form.TreeWeight.changeSelect2(e => {
                if (this.form.TreeWeight.value < this.form.BaseWeight.value) {
                    q.alert('', 'Tree weight cannot be less than Base Weight', true, 2999);
                    return;
                }
                this.calculateMetalRequired();
            });
            this.form.ConversionFactor.changeSelect2(e => {
                this.calculateMetalRequired();
            });
            this.form.ButtonWeight.changeSelect2(e => {
                this.calculateMetalRequired();
            });
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                this.calculateItemDetailsData();
                this.calculateMetalRequired();
            });



            (this.form.IssueDetails.view as any).onRowCountChanged.subscribe(() => {
                this.calculateIssuedData();

            });

            (this.form.ReceiptDetail.view as any).onRowCountChanged.subscribe(() => {
                this.calculateReceivedData();
            });

        }

        public calculateItemDetailsData() {
            var Items = this.form.ItemDetails.getItems();
            var Wt = 0, cts = 0, gms = 0, diapcs = 0, clrpcs = 0 ;
            if (Items.length > 0) {
                for (var i = 0; i < Items.length; i++) {
                    var item = Items[i];
                    if (item.HasBom) {

                        for (var k of item.BOMDetails) {

                            if (k.ItemTypeId == 104) {
                                Wt += k.Weight;
                            }
                            if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                                cts += k.Weight;
                                diapcs += k.Pieces
                            }
                            if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                                gms += k.Weight;
                                clrpcs += k.Pieces;
                            }
                        }


                    }
                    else if (!item.HasBom && item.ItemTypeId == 101) {
                        var j = item;
                        if (j.ItemTypeId == 104) {
                            Wt += j.Weight;
                        }
                        if (j.ItemTypeId == 105 && j.CalcOnId == 5) {
                            cts += j.Weight;
                            diapcs += j.Pieces
                        }
                        if (j.ItemTypeId == 105 && j.CalcOnId == 4) {
                            gms += j.Weight;
                            clrpcs += j.Pieces;
                        }

                    }

                }
                this.form.StoneWeight.value = gms;
                this.form.MetalConsumed.value = Wt;
                //if (cts > 0)
                this.form.DiamondWeight.value = cts;
                q.showAndDisableField(this.form.DepartmentId);
                q.showAndDisableField(this.form.RMDepartmentId);
                q.showAndDisableField(this.form.ProcessId);
                q.showAndDisableField(this.form.KaratId);
                q.showAndDisableField(this.form.MetalColorId);
                q.showAndDisableField(this.form.TreeNo);
                q.showAndDisableField(this.form.TreeWeight);
                q.showAndDisableField(this.form.BaseWeight);
                q.showAndDisableField(this.form.ButtonWeight);
                q.showAndDisableField(this.form.ConversionFactor);
            }
            else if (Items.length == 0) {
                q.showAndEnableField(this.form.DepartmentId);
                q.showAndEnableField(this.form.RMDepartmentId);
                q.showAndEnableField(this.form.ProcessId);
                q.showAndEnableField(this.form.KaratId);
                q.showAndEnableField(this.form.MetalColorId);
                q.showAndEnableField(this.form.TreeNo);
                q.showAndEnableField(this.form.TreeWeight);
                q.showAndEnableField(this.form.BaseWeight);
                q.showAndEnableField(this.form.ButtonWeight);
                q.showAndEnableField(this.form.ConversionFactor);
            }
        }


        public calculateIssuedData() {
            var Items = this.form.IssueDetails.getItems();
            if (Items.length > 0) {
                var weight = 0, purity = 0;
                for (var i = 0; i < Items.length; i++) {

                    var item = Items[i];
                    if (item.ProductTypeId != 10) {
                        weight += item.Weight;
                        purity += item.Purity;

                    }

                }
                //pureweight = (weight * purity);
                this.form.MetalIssued.value = weight;
                this.form.MetalBalance.value = weight - this.form.MetalConsumed.value;
                //this.form.ReceivableWeight.value = receivableweight;
                //this.form.IssuedAlloy.value = alloyweight;
                //this.form.RequiredAlloyTemp.value = alloyrequired;
            }  
        }

        public calculateReceivedData() {
            var Items = this.form.ReceiptDetail.getItems();
            if (Items.length > 0) {

                q.showAndDisableField(this.form.KaratId);
                q.showAndDisableField(this.form.MetalColorId);
                var weight = 0;
                for (var i = 0; i < Items.length; i++) {

                    var item = Items[i];
                    weight += item.Weight;

                }
                var metalbalance = this.form.MetalBalance.value;
                var loss = metalbalance - weight;
                this.form.Loss.value = loss;
                this.form.LossPercent.value = (loss / metalbalance) * 100;

            } else if (Items.length == 0) {
                q.showAndEnableField(this.form.KaratId);
                q.showAndEnableField(this.form.MetalColorId);
                this.form.Loss.value = 0;
                this.form.LossPercent.value = 0;
            }
        }

        public calculateMetalRequired() {
            var treeweight = this.form.TreeWeight.value == null ? 0 : this.form.TreeWeight.value;
            var baseweight = this.form.BaseWeight.value == null ? 0 : this.form.BaseWeight.value;
            var stoneweight = this.form.StoneWeight.value == null ? 0 : this.form.StoneWeight.value;
            var diamondweight = this.form.DiamondWeight.value == null ? 0 : this.form.DiamondWeight.value;
            var buttonweight = this.form.ButtonWeight.value == null ? 0 : this.form.ButtonWeight.value;
            var conversionfactor = this.form.ConversionFactor.value == null ? 0 : this.form.ConversionFactor.value;

            var metalrequired = ((treeweight - baseweight - stoneweight - (diamondweight/5)) * conversionfactor) + buttonweight;
            this.form.MetalRequired.value = metalrequired;
            this.form.MetalBalance.value = this.form.MetalIssued.value - this.form.MetalConsumed.value;
        }
        onDialogClose() {
            super.onDialogClose();
            this.Closing = true;

        }

        //validateBeforeSave() {
        //    var receivableweight = this.form.ReceivableWeight.value;
        //    var receivedweight = this.form.ReceivedWeight.value;
        //    var loss = this.form.Loss.value;
        //    if (receivableweight != (receivedweight + loss)) {
        //        q.Alert('Invalid Entry', 'Total Weights do not Match', 1000, false);
        //        return false;
        //    }
        //    return true;
        //}

        //protected getToolbarButtons(): Serenity.ToolButton[] {
        //    let btns = super.getToolbarButtons();
        //    var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
        //    var oldDeleteClick = btnDelete.onClick;
        //    btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

        //    //Edit Click Override
        //    var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
        //    var oldEditClick = btnEdit.onClick;
        //    btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };
        //    ////Export PDF Button
        //    //btns.push(TabAurous.Common.ReportHelper.createToolButton({
        //    //    title: 'Invoice',
        //    //    cssClass: 'export-pdf-button',
        //    //    reportKey: 'Reports.PurchaseMaster',
        //    //    getParams: () => ({
        //    //        TransID: this.get_entityId()
        //    //    })
        //    //}));

        //    return btns;
        //}

        // #region Edit Delete Validation
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            var returnproduct = this.form.ReceiptDetail.getItems()[0];

            let CurrentStock: Stock.StockItemRow;

            Stock.StockItemService.GetProductDetails({
                ProductId: returnproduct.ProductId,
                AttributeId: returnproduct.AttributeId,
            },
                response =>
                    CurrentStock = response.Entity,
                { async: false }
            );
            //if (CurrentStock.Weight < this.form.ReceivableWeight.value) {

            //        Q.alert("This Voucher has been used in transactions Can Not Delete!");
            //        return;

            //} else {
            //    Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
            //    this.form.ItemDetails.canUpdate = 1;
            //    if (!self.isEditMode())
            //        return;
            //    self.editClicked = true;
            //    self.updateInterface();
            //    self.updateTitle();
            //}
        }

        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            var returnproduct = this.form.ReceiptDetail.getItems()[0];

            let CurrentStock: Stock.StockItemRow;

            Stock.StockItemService.GetProductDetails({
                ProductId: returnproduct.ProductId,
                AttributeId: returnproduct.AttributeId,
            },
                response =>
                    CurrentStock = response.Entity,
                { async: false }
            );
            //if (CurrentStock.Weight < this.form.ReceivableWeight.value) {
            //       Q.alert("This Voucher has been used in transactions Can Not Delete!");
            //        return; 
            //} else {

            //    Swal.fire({
            //        title: 'Are you sure?',
            //        text: "You won't be able to revert this!",
            //        icon: 'warning',
            //        showCancelButton: true,
            //        confirmButtonColor: '#3085d6',
            //        cancelButtonColor: '#d33',
            //        confirmButtonText: 'Yes, delete it!'
            //    }).then((result) => {
            //        if (result.isConfirmed) {
            //           TreeMakingService.Delete(
            //                {
            //                    EntityId: this.entityId
            //                }, response => {
            //                    Serenity.SubDialogHelper.triggerDataChange(self);
            //                    self.dialogClose();
            //                    window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
            //                        Swal.fire({
            //                            icon: 'success',
            //                            title: 'Deleted!',
            //                            text: 'Voucher Deleted',
            //                            showConfirmButton: false,
            //                            timer: 1500
            //                        })
            //                    );
            //                }
            //            );
            //        }
            //    })
            //}
        }

    }
}